"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getString = void 0;

var _strings = require("../../../../config/strings");

var STRINGS = {
  EUROFH_NO_PORTAL_TITLE: {
    de: 'Keine Daten vorhanden',
    en: 'No data'
  },
  EUROFH_NO_PORTAL_TEXT: {
    de: 'Bitte starte Sie die Anwendung erneut aus dem Euro FH Portal.',
    en: 'Please restart the application out of the Euro FH Portal.'
  }
};

function addStringsToGlobalList() {
  if (!_strings.addStrings) {
    console.log('addStrings is still null');
    setTimeout(addStringsToGlobalList, 50);
    return;
  } // console.log('addstrings is possible now')


  (0, _strings.addStrings)(STRINGS);
}

addStringsToGlobalList(); // named export for better import proposals by webstorm

var getString = function getString() {
  return _strings.getString.apply(void 0, arguments);
};

exports.getString = getString;